/** Anonymous per-browser id for view de-duplication (sent as X-Session-ID). */
export function sessionId(): string {
  try {
    let id = localStorage.getItem("rs_sid");
    if (!id) {
      id = crypto.randomUUID();
      localStorage.setItem("rs_sid", id);
    }
    return id;
  } catch {
    return "";
  }
}
